import { createAction } from '@reduxjs/toolkit';

type Column = {
  id: string;
};
export const setTableColumnsProductBalances = createAction<{ active: Column[] }>(
  'table-columns/product-balances/set'
);

export const setTableColumnsCampaignsList = createAction<{ active: Column[] }>(
  'table-columns/campaigns-list/set'
);

export const setTableColumnsCampaignProductsList = createAction<{ active: Column[] }>(
  'table-columns/campaign-products-list/set'
);
